const YearView = ({
  currentDate = new Date(),
  onDateClick,
}) => {
  const year = currentDate.getFullYear();
  const weekDays = ["S", "M", "T", "W", "T", "F", "S"];

  const getDaysInMonth = (year, month) =>
    new Date(year, month + 1, 0).getDate();

  const getStartDay = (year, month) =>
    new Date(year, month, 1).getDay();

  return (
    <div className="year-container">
      {Array.from({ length: 12 }).map((_, month) => {
        const daysInMonth = getDaysInMonth(year, month);
        const startDay = getStartDay(year, month);

        return (
          <div key={month} className="month-card">

            <div className="month-title">
              {new Date(year, month).toLocaleString("default", {
                month: "long",
              })}
            </div>


            <div className="year-week-header">
              {weekDays.map((d) => (
                <span key={d}>{d}</span>
              ))}
            </div>


            <div className="days-grid">

              {Array.from({ length: startDay }).map((_, i) => (
                <span key={`empty-${i}`} />
              ))}


              {Array.from({ length: daysInMonth }).map((_, day) => (
                <span
                  key={day}
                  className="day"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    onDateClick &&
                    onDateClick(new Date(year, month, day + 1))
                  }
                >
                  {day + 1}
                </span>
              ))}

            </div>
          </div>
        );
      })}
    </div>
  );
};

export default YearView;
